document.addEventListener('DOMContentLoaded', function() {
  flatpickr("#wed-date", {
    enableTime: false,  // No time selection, only date
    dateFormat: "Y-m-d",  // Format the date as Year-Month-Day (adjust as needed)
    minDate: "today",  // Disable past dates
  });
});
